export enum SaleStatus {
  FOR_SALE = "판매 중",
  NOT_FOR_SALE = "판매 안함",
}
